import {apiHelper} from "../redux/apiHelper"
export const getAdvertisment=async()=>{
    try{
       let res=await apiHelper('get','/api/admin/adds-section/list');
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
 }
 export const addAdvertisment=async(data)=>{

    try{
        let res=await apiHelper('post',`/api/admin/adds-section/create`,data);
        if(res){
          return res;
        }
     }catch(e){
        console.log(e);
     }
 }
 export const updateAdvertisment=async(id,data)=>{
   try{
       let res=await apiHelper('post',`/api/admin/adds-section/update/${id}`,data);
       if(res){
         return res;
       }
    }catch(e){
       console.log(e);
    }
}
export const getAdvertismentById=async(id)=>{
   try{
       let res=await apiHelper('get',`/api/admin/adds-section/get/${id}`);
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
}
 export const deleteAdvertismentId=async(id)=>{
    try{
        let res=await apiHelper('delete',`/api/admin/adds-section/delete/${id}`);
        if(res){
          return res;
        }
     }catch(e){
      console.log(e);
     }
    
}